"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TableRow = function TableRow(_ref) {
  var isTableHeading = _ref.isTableHeading,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["isTableHeading", "children"]);

  var childrenWithProps = _react.default.Children.map(children, function (child) {
    return _react.default.cloneElement(child, {
      isTableHeading: isTableHeading
    });
  });

  return _react.default.createElement("tr", props, childrenWithProps);
};

TableRow.displayName = 'TableRow';
TableRow.propTypes = {
  /**
   * Apply styles for table heading. NOTE: Will get automatically get passed
   * as `true` if used within a `TableHead` component.
   */
  isTableHeading: _propTypes.default.bool,

  /** Any classnames that you want to apply to the component */
  className: _propTypes.default.string,

  /** Contents of the Table Row */
  children: _propTypes.default.node
};
var _default = TableRow;
exports.default = _default;